import styled from "styled-components";
import { FlexContainers } from "../../../components";

export const FleetManagementControlsWrapper = styled(FlexContainers.FlexRowBetween)`
  width: 100%;
  gap: 16px;
  align-items: flex-start;
`;
